/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Hubs_Signals_Faq_Improve_QInputs */

const en_directory_hubs_signals_faq_improve_q = /** @type {(inputs: Directory_Hubs_Signals_Faq_Improve_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How do I improve my AI-Ready score?`)
};

const zh_directory_hubs_signals_faq_improve_q = /** @type {(inputs: Directory_Hubs_Signals_Faq_Improve_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`怎样提高 AI-Ready 分数？`)
};

/**
* | output |
* | --- |
* | "How do I improve my AI-Ready score?" |
*
* @param {Directory_Hubs_Signals_Faq_Improve_QInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_hubs_signals_faq_improve_q = /** @type {((inputs?: Directory_Hubs_Signals_Faq_Improve_QInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Hubs_Signals_Faq_Improve_QInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_hubs_signals_faq_improve_q(inputs)
	return zh_directory_hubs_signals_faq_improve_q(inputs)
});
export { directory_hubs_signals_faq_improve_q as "directory.hubs.signals.faq.improve_q" }